var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{directives:[{name:"mask",rawName:"v-mask",value:(_vm.mask),expression:"mask"}],key:_vm.inputKey,ref:"phoneInput",attrs:{"solo":"","placeholder":_vm.placeholder,"error-messages":_vm.errorMessages},on:{"change":_vm.change},model:{value:(_vm.phone),callback:function ($$v) {_vm.phone=$$v},expression:"phone"}})
}
var staticRenderFns = []

export { render, staticRenderFns }